import { documentSignsService } from '@/services';
import { ISignCommand } from '@/sign/commands/isign.command';
import { SigningParamsContainer } from '@/sign/models/signing-params.model';
import { disableShowMsg, enableShowMsg, setLoadingProgress, setLoadingText } from '@/mixins/ui-mixin';
import { ContragentSignDocumentSignStrategyFactory } from '../factories/contragent-sign-document-sign-strategy.factory';
import { eDocumentSignUserStatus } from '@/models/enums';
import { BaseSignDocumentCommand } from './sign-document.command';
import { DocumentSignVisualizationHelper } from '@/helpers/document-sign-visualization.helper';
import { getLocale } from '@/helpers';
import { unregUserDocService } from '@/services/unregistered-user-document.service';
import { isUnregUserView } from '@/helpers/ui-helper';
import { IDocumentActionUserDecisionResult } from '@/models/document-actions.model';

export class SignDocumentContragentCommand extends BaseSignDocumentCommand implements ISignCommand {
  constructor(signStrategyParams: any) {
    super(signStrategyParams, new ContragentSignDocumentSignStrategyFactory());
    this.isSealAllowed = true;
  }

  public async execute(signMethodParams: SigningParamsContainer): Promise<any> {
    disableShowMsg();
    try {
      const ret = await super.execute(signMethodParams);

      const visHelper = new DocumentSignVisualizationHelper();

      setLoadingText({ text: getLocale('appLoading.saveDocumentSignatures').toString() });
      const saveResult = await this.saveSignes(ret.keySigningResult, ret.sealSigningResult);
      setLoadingText({ text: '' });

      if (saveResult && saveResult.isSuccess) {
        let files = ret.keySigningResult.map(sh => sh.pDocumentVersionsFileCode);
        setLoadingText({ text: getLocale('appLoading.createDocumentFileVisualization').toString() });
        await visHelper.update(this.signStrategyParams.documentVersionCode, files, (total, current) => {
          setLoadingProgress({ total, current, showTotal: true });
        });
        setLoadingText({ text: '' });
      }

      return saveResult;
    } finally {
      enableShowMsg();
    }
  }

  private async saveSignes(signedHashes, stampSignedHashes): Promise<IDocumentActionUserDecisionResult> {
    let result;
    try {
      if (isUnregUserView()) {
        result = await unregUserDocService.makeSignDecision(this.signStrategyParams.documentVersionCode, this.signStrategyParams.documentSignUserId,
          eDocumentSignUserStatus.SIGNEND, signedHashes, stampSignedHashes, '');
      } else {
        result = await documentSignsService.userDecision(this.signStrategyParams.documentSignUserId, eDocumentSignUserStatus.SIGNEND,
          signedHashes, stampSignedHashes);
      }
    } catch (err) {
      await this.handleSignSavingError(err);
    }

    return result;
  }
}
